import VCNewFund from "./VCNewFund";

export default VCNewFund;
